

/* import B_DialogueData from "../data/json/B_DialogueData.json";
 * import C_DialogueData from "../data/json/C_DialogueData.json";
 * import E_DialogueData from "../data/json/E_DialogueData.json"; */

const VERBOSE = false;

var dialogue = null;
var state = null;

const setLocal = (field, value) => {
    localStorage.setItem(field, JSON.stringify(value));
};

const getLocal = (field) => {
    try { return JSON.parse(localStorage.getItem(field)); }
    catch (error) { return null; }
};

export function start (content)
{
    dialogue = { lines: [], labelNums: {} };

    const lines = [...content.matchAll(/\[([^\]]*)\](.*?(?=\[|$))/g)];

    let num = 0;
    lines.forEach((line) => {
	const words = line[1].split(/\s+/);
	const tag = words[0];
	const params = words.slice(1);
	const text = line[2].trim();

	dialogue.lines[num] = { num, tag, params, text };
	if (tag === "label") dialogue.labelNums[params[0]] = num;

	num++;
    });

    const localState = getLocal("dialogueState");
    if (localState !== null) state = localState;
    else {
	state = { head: null, previousNums: [], badges: [] };
	setLocal("dialogueState", state);
    }

    if (VERBOSE)
    {
	console.log("DIALOGUE");
	console.log(dialogue);
    }
}


export function current ()
{
    if (state.head === null) return null;

    let currentDialogue = {
	charId: null,
	text: "",
	choices: [],
	interfaces: [],
	events: [],
	solutions: [],
	documents: [],
	informations: [],
	items: [],
	openChars: [],
	closeChars: [],
	openChoices: [],
	closeChoices: [],
	badges: [],
	end: false
    };

    if (VERBOSE)
    {
	console.log("STATE");
	console.log(state);
    }
    
    // GET TEXT
    if (state.head.nums["text"] !== undefined)
    {
	const textLine = dialogue.lines[state.head.nums["text"][0]];
	currentDialogue.charId = textLine.params[0];
	currentDialogue.text = textLine.text;
    }

    // GET CHOICES
    if (state.head.nums["choice"] !== undefined)
    {
	currentDialogue.choices = state.head.nums["choice"].map((num) => {
	    const choiceLine = dialogue.lines[num];
	    return {
		num: choiceLine.num,
		text: choiceLine.text,
		label: choiceLine.params[0],
		time: choiceLine.params.length > 1 && choiceLine.params[1] !== "default" ? parseInt(choiceLine.params[1]) : null,
		opened: choiceLine.params.length > 2 && choiceLine.params[2] === "opened"
	    };
	});
    }

    // GET INTERFACES
    if (state.head.nums["interface"] !== undefined)
    {
	currentDialogue.interfaces = state.head.nums["interface"].map((num) => {
	    const interfaceLine = dialogue.lines[num];
	    return {
		num: interfaceLine.num,
		text: interfaceLine.text,
		params: interfaceLine.params
	    };
	});
    }

    // GET EVENTS
    if (state.head.nums["event"] !== undefined) currentDialogue.events = state.head.nums["event"].flatMap((num) => dialogue.lines[num].params);
    
    // GET ITEMS
    if (state.head.nums["add-solution"] !== undefined) currentDialogue.solutions = state.head.nums["add-solution"].map((num) => dialogue.lines[num].params[0]);
    if (state.head.nums["add-document"] !== undefined) currentDialogue.documents = state.head.nums["add-document"].map((num) => dialogue.lines[num].params[0]);
    if (state.head.nums["add-item"] !== undefined) currentDialogue.items = state.head.nums["add-item"].map((num) => dialogue.lines[num].params[0]);
    if (state.head.nums["show-information"] !== undefined) currentDialogue.informations = state.head.nums["show-information"].map((num) => dialogue.lines[num].params[0]);

    // GET OPEN AND CLOSE CHARS
    if (state.head.nums["open-char"] !== undefined) currentDialogue.openChars = state.head.nums["open-char"].map((num) => { return { id: dialogue.lines[num].params[0] }; });
    if (state.head.nums["close-char"] !== undefined) currentDialogue.closeChars = state.head.nums["close-char"].map((num) => { return { id: dialogue.lines[num].params[0] }; });

    // GET OPEN AND CLOSE CHOICES
    if (state.head.nums["open-choice"] !== undefined) currentDialogue.openChoices = state.head.nums["open-choice"].map((num) => {
	const line = dialogue.lines[num];
	const id = line.params[0];
	const charId = line.params[1];
	const itemIds = line.params.slice(2);
	return { id, charId, itemIds };
    });

    if (state.head.nums["close-choice"] !== undefined) currentDialogue.closeChoices = state.head.nums["close-choice"].map((num) => {
	const line = dialogue.lines[num];
	const id = line.params[0];
	const charId = line.params[1];
	return { id, charId };
    });

    // GET BADGES
    if (state.head.nums["add-badge"] !== undefined) currentDialogue.badges = state.head.nums["add-badge"].map((num) => {
	const line = dialogue.lines[num];
	const id = line.params[0];
	return { id };
    });

    // GET END
    if (state.head.nums["end"] !== undefined && state.head.nums["choice"] === undefined) { currentDialogue.end = true; }

    if (VERBOSE)
    {
	console.log("CURRENT DIALOGUE");
	console.log(currentDialogue);
    }
    
    return currentDialogue;
}

export function goto (label) {
    getHead(dialogue.labelNums[label]);
}

export function next () { getHead(state.head.num+1); }

export function addBadge (badgeId)
{
    if (!state.badges.includes(badgeId))
    {
	state.badges.push(badgeId);
	setLocal("dialogueState", state);
    }
}

function getHead (num)
{
    state.head = {
	num,
	nums: {}
    };

    let tempNum = num;
    let tempPreviousNums = [];
    
    let blockStart = false;
    let blockEnd = false;

    function register (tag)
    {
	if (state.head.nums[tag] === undefined) state.head.nums[tag] = [];
	state.head.nums[tag].push(tempNum);
	state.head.num = tempNum;
	state.previousNums = state.previousNums.concat(tempPreviousNums);
	tempPreviousNums = [];
    }

    while (! blockEnd)
    {
	if (tempNum >= dialogue.lines.length) { blockEnd = true; }

	else {
	    tempPreviousNums.push(tempNum);
	    const line = dialogue.lines[tempNum];
	    const tag = line.tag;
	    
	    if (VERBOSE)
	    {
		console.log("LINE");
		console.log(line);
	    }
	    
	    switch (tag)
	    {
		case "text" :
		if (blockStart) blockEnd = true;
		else {
		    blockStart = true;
		    register(tag);
		}
		break;

		case "choice" :
		case "interface" :
		blockStart = true;
		register(tag);
		break;

		case "event" :
		blockStart = true;
		register(tag);
		break;

		case "end" :
		blockEnd = true;
		register(tag);
		break;

		case "add-badge" :
		case "add-solution" :
		case "add-document" :
		case "add-item" :
		case "show-information" :
		case "open-char" :
		case "close-char" :
		case "open-choice" :
		case "close-choice" :
		register(tag);
		break;

		case "jump" :
		tempNum = dialogue.labelNums[line.params[0]];		
		break;

		case "start-if" :
		let check = true;
		for (let i = 0; i < line.params.length; i++)
		{
		    let param = line.params[i];

		    let bool = true;
		    if (param.substring(0,4) === "not(" && param.substring(param.length-1) === ")")
		    {
			bool = false;
			param = param.substring(4, param.length -1);
		    }

		    let value = false;
		    if (param === "first") value = !state.previousNums.includes(tempNum);
		    else value = state.badges.includes(param);
		    
		    check = check && ((bool && value) || (!bool && !value));
		}
		
		if (! check)
		{
		    tempNum++;
		    let tempTag = dialogue.lines[tempNum].tag;

		    let startIfNb = 0;
		    while (startIfNb > 0 || (tempTag !== "start-else" && tempTag !== "end-if"))
		    {
			if (tempTag === "start-if") startIfNb++;
			else if (tempTag === "end-if" && startIfNb > 0) startIfNb--;
			tempNum++;
			tempTag = dialogue.lines[tempNum].tag;
		    }
		}
		break;
		
		case "start-else" :
		tempNum++;
		let tempTag = dialogue.lines[tempNum].tag;

		let startIfNb = 0;
		while (startIfNb > 0 || tempTag !== "end-if")
		{
		    if (tempTag === "start-if") startIfNb++;
		    else if (tempTag === "end-if" && startIfNb > 0) startIfNb--;
		    tempNum++;
		    tempTag = dialogue.lines[tempNum].tag;
		}
		break;

		default :
	    }

	    tempNum++;
	}
    }

    setLocal("dialogueState", state);
}


